import {
  Button,
  Col,
  FieldLabel,
  Form,
  type OperationType,
  Row,
} from '@/components';
import { useProjectFormContext } from '@/features/project/_hooks/form-context';
import type { sheetTypeEnum } from '@/utils/enum';
import { PlusOutlined } from '@ant-design/icons';
import type { FC } from 'react';
import { useFieldArray } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { z } from 'zod';
import { RelatedProjectField } from './RelatedProjectField';

type Props = {
  operation: OperationType;
  type: z.infer<typeof sheetTypeEnum>;
  ignoredProjectIds?: string[];
};
export const RelatedProjectArrayField: FC<Props> = (props) => {
  const { control } = useProjectFormContext();

  const { t } = useTranslation();

  const {
    fields: relatedProjectFields,
    append: appendRelatedProject,
    remove: removeRelatedProject,
  } = useFieldArray({
    control,
    name: 'data.relatedProjects',
  });

  return (
    <Form.Item
      label={
        <FieldLabel
          hint={
            props.type === 'KS'
              ? t('hint-related-projects-for-ks')
              : props.type === 'RS'
                ? t('hint-related-projects-for-rs')
                : t('hint-related-projects-for-ss')
          }
          text={t('related-projects')}
        />
      }
    >
      <Row gutter={[24, 8]}>
        {relatedProjectFields.map((item, idx) => {
          return (
            <Col key={item.id} span={24}>
              <RelatedProjectField
                {...props}
                idx={idx}
                removeRelatedProject={removeRelatedProject}
              />
            </Col>
          );
        })}
        <Col span={12}>
          <Button
            type="dashed"
            onClick={() => {
              appendRelatedProject({
                id: '',
                relationType: 'others-base',
              });
            }}
            block
            icon={<PlusOutlined />}
          >
            {t('add-related-project')}
          </Button>
        </Col>
      </Row>
    </Form.Item>
  );
};
